import React from 'react';
import { Accordion, AccordionSummary, AccordionDetails, Grid } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DropdownCheckBox from '../styledComponents/DropdownCheckBox';

export const HomebranchAccordion = ({
    mallNames,
    handleHomebranches,
    crossFilteredIsLoading,
    cross_filtered_data,
}) => {
    const listOfMalls = mallNames?.map((mall) => {
        const words = mall.split(' ');
        const capitalizedWords = words.map((word, index) => {
            if (index === 0) {
                return word.toUpperCase();
            }
            return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
        });
        const formattedMall = capitalizedWords.join(' ');

        return { label: formattedMall };
    }).sort((a, b) => a.label.localeCompare(b.label));

    return (
        <Accordion sx={{ width: '100%' }}>
            <AccordionSummary
                sx={{ backgroundColor: '#F6F6F8', color: '#00000', fontWeight: 700 }}
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2-content"
                id="panel2-header"
            >
                Homebranch
            </AccordionSummary>
            <AccordionDetails>
                <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    direction="row"
                >
                    <Grid item xs={12}>
                        <DropdownCheckBox
                            label="Homebranch"
                            options={listOfMalls}
                            handleSelectionChange={handleHomebranches}
                            disabled={crossFilteredIsLoading && cross_filtered_data === undefined}
                            loading={crossFilteredIsLoading && cross_filtered_data === undefined}
                        />
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion>
    );
};